import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Button from "../../components/Button";
import Icon from "../../components/Icon";
import EditableLabel from "../../components/EditableLabel";
import {
  Toolbar,
  ToolbarGroup,
  ToolbarFlexibleSpacer,
} from "../../components/Toolbar";
import {
  toggleEditorBreakdown,
  updateEmailTemplate,
  toggleEditModuleHtml,
  toggleEditModuleCss,
  toggleEditModuleData,
  toggleEditModulePreview,
  updateEditTemplateNameValue,
} from "../../actions";

export class EditEmailTemplateToolbar extends Component {
  constructor(props) {
    super(props);
    this.save = this.save.bind(this);
    this.onUpdateName = this.onUpdateName.bind(this);
  }

  onUpdateName(newName) {
    this.props.updateEditTemplateNameValue(newName);
  }

  save() {
    const { accountId } = this.props;
    if (this.props.emailTemplate.id) {
      this.props.updateEmailTemplate(
        accountId,
        this.props.emailTemplate.id,
        this.props.emailTemplate
      );
    }
  }

  render() {
    const { emailTemplate, unsavedChanges, showHtml, showData, accountId } =
      this.props;

    return (
      <Toolbar>
        <ToolbarGroup width="300px">
          <EditableLabel
            value={emailTemplate.name}
            onChange={this.onUpdateName}
            width="300px"
          />
        </ToolbarGroup>

        <ToolbarFlexibleSpacer />

        <ToolbarGroup width="400px" align="center">
          <Button
            type={showHtml ? "button" : "link"}
            onClick={this.props.toggleEditModuleHtml}
          >
            HTML
          </Button>
          <Button
            type={showData ? "button" : "link"}
            onClick={this.props.toggleEditModuleData}
          >
            Data
          </Button>
          {/*<Button type={showPreview ? 'button' : 'link'} onClick={this.props.toggleEditModulePreview}>Preview</Button>*/}
        </ToolbarGroup>

        <ToolbarFlexibleSpacer />

        <ToolbarGroup width="300px" align="right">
          <Link to={`/clients/${accountId}/email-templates`}>
            <Button type="link">
              <Icon icon="close" title="Close" />
            </Button>
          </Link>
          <Button
            color={unsavedChanges ? "primary" : "greyed"}
            disabled={!unsavedChanges}
            onClick={this.save}
          >
            Save
          </Button>
        </ToolbarGroup>
      </Toolbar>
    );
  }
}

// Connect state data
function mapStateToProps(state) {
  const { emailTemplate, unsavedChanges, showHtml, showData } =
    state.emailTemplateEditor;
  return {
    emailTemplate,
    unsavedChanges,
    showHtml,
    showData,
  };
}

// Connect actions
export default connect(mapStateToProps, {
  toggleEditorBreakdown,
  updateEmailTemplate,
  toggleEditModuleHtml,
  toggleEditModuleCss,
  toggleEditModuleData,
  toggleEditModulePreview,
  updateEditTemplateNameValue,
})(EditEmailTemplateToolbar);
